import React from "react";
import { Bot, Sparkles, Zap, Atom, Rocket, Compass, Wind, Cpu, Layers } from "lucide-react";

// Brand config using lucide icons + accent classes. New providers can be
// added below — the accent class is defined in index.css.
export function modelBrand(id) {
  switch (id) {
    case "openai":
      return { Icon: Atom, accentClass: "accent-openai", tag: "OA" };
    case "anthropic":
      return { Icon: Sparkles, accentClass: "accent-anthropic", tag: "AN" };
    case "google":
      return { Icon: Zap, accentClass: "accent-google", tag: "GM" };
    case "xai":
      return { Icon: Rocket, accentClass: "accent-xai", tag: "XA" };
    case "deepseek":
      return { Icon: Bot, accentClass: "accent-deepseek", tag: "DS" };
    case "perplexity":
      return { Icon: Compass, accentClass: "accent-perplexity", tag: "PX" };
    case "mistral":
      return { Icon: Wind, accentClass: "accent-mistral", tag: "MS" };
    case "cohere":
      return { Icon: Cpu, accentClass: "accent-cohere", tag: "CO" };
    case "meta":
      return { Icon: Layers, accentClass: "accent-meta", tag: "ML" };
    default:
      return { Icon: Bot, accentClass: "accent-openai", tag: "AI" };
  }
}
